import { render } from "./CallCard.vue?vue&type=template&id=89127422"
import script from "./CallCard.vue?vue&type=script&lang=js"
export * from "./CallCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__